const IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'heic', 'avif', 'bmp']

export interface FileTypeInfo {
  format?: string
  type?: string
  src?: string
}

export function isPdfFile(file: FileTypeInfo): boolean {
  if (file?.format === 'pdf' || file?.type === 'application/pdf') return true
  if (!file?.src) return false
  const path = file.src.split('?')[0]?.toLowerCase() ?? ''
  return path.endsWith('.pdf')
}

export function isImageFile(file: FileTypeInfo): boolean {
  if (file?.format?.startsWith('image') || file?.type?.startsWith('image')) return true
  if (file?.format && IMAGE_FORMATS.includes(file.format.toLowerCase())) return true
  if (!file?.src) return false
  const ext = file.src.split('?')[0]?.split('.').pop()?.toLowerCase() ?? ''
  return IMAGE_FORMATS.includes(ext)
}
